<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>Adathiba jelzése</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <datalist id="aj-csoportok">
    <option *ngFor="let c of csoportok" [value]="c.nev">{{ csoportCimke(c) }}</option>
  </datalist>
  <datalist id="aj-tantargyak">
    <option *ngFor="let t of tantargyak" [value]="t.nev"></option>
  </datalist>
  <datalist id="aj-tanulok">
    <option *ngFor="let t of tanuloTalalatok" [value]="tanuloCimke(t)"></option>
  </datalist>

  <!-- ══ VÁLASZTÓ ════════════════════════════════════════════════════════ -->
  <ion-card *ngIf="!tipus">
    <ion-card-header>
      <ion-card-title>Mi a hibás?</ion-card-title>
      <ion-card-subtitle>
        Válaszd ki, és töltsd ki a pár mezőt – a rendszer azonnal javítja. Beküldés előtt megmutatjuk,
        pontosan mi fog változni. Ha valami téves, az adminisztrátor visszavonja.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="aj-siker" *ngIf="siker">
        ✔ Rögzítve{{ siker.kezi ? ' – kézi javításra vár' : ' és javítva' }}: {{ siker.osszegzes }}
      </div>
      <div class="aj-hiba" *ngIf="hiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ hiba }}</div>
      <div class="aj-tipusok">
        <button type="button" class="aj-tipus" *ngFor="let t of tipusok" (click)="valaszt(t.kod)">
          <ion-icon [name]="t.ikon"></ion-icon>
          <div><b>{{ t.cim }}</b><span>{{ t.leiras }}</span></div>
        </button>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- ══ ŰRLAP ═══════════════════════════════════════════════════════════ -->
  <ion-card *ngIf="tipus">
    <ion-card-header>
      <ion-card-title>{{ tipusCim(tipus) }}</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <div class="aj-urlap">

        <!-- Csoportváltás / jogviszony: a tanuló -->
        <ng-container *ngIf="tipus === 'csoport_valtas' || tipus === 'jogviszony'">
          <div class="aj-mezo">
            <label>Tanuló (név vagy oktatási azonosító)</label>
            <input list="aj-tanulok" [(ngModel)]="tanuloKereso" (ngModelChange)="tanuloKeres()" placeholder="pl. Kovács Anna"
                   [disabled]="!!tanulo" autocomplete="off">
            <div *ngIf="tanulo" class="aj-gombok">
              <span class="aj-sug">Jelenlegi csoportjai:</span>
              <ion-button size="small" fill="clear" (click)="tanuloTorol()">másik tanuló</ion-button>
            </div>
            <div class="aj-chipek" *ngIf="tanulo">
              <ion-chip *ngFor="let c of tanuloCsoportjai" outline>{{ c.nev }}<span *ngIf="c.kezdete">&nbsp;({{ c.kezdete }}-tól)</span></ion-chip>
              <span class="aj-sug" *ngIf="!tanuloCsoportjai.length">nincs csoportja</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="tipus === 'jogviszony' && tanulo">
          <div class="aj-sor">
            <div class="aj-mezo">
              <label>Mi történt?</label>
              <select [(ngModel)]="f.allapot" (ngModelChange)="valtozott()">
                <option value="szunetel">A jogviszonya szünetel (pl. külföldön tanul)</option>
                <option value="aktiv">Újra jár (a szünetelés véget ért)</option>
                <option value="kilep">Kiiratkozott / kilépett</option>
              </select>
            </div>
            <div class="aj-mezo">
              <label>Melyik naptól?</label>
              <input type="date" [(ngModel)]="f.datum" (ngModelChange)="valtozott()" [min]="tanev.tankezd" [max]="tanev.tanvege">
            </div>
          </div>
          <div class="aj-mezo" *ngIf="f.allapot === 'kilep'">
            <label>Kilépés oka (nem kötelező)</label>
            <input [(ngModel)]="f.ok" maxlength="200" placeholder="pl. más iskolába ment">
          </div>
          <span class="aj-sug">Szünetelés alatt a tanuló nem szerepel a névsorokban, így hiányzónak és jegyre sem írható.
            Kilépésnél a csoporttagságai is lezárulnak.</span>
        </ng-container>
        <ng-container *ngIf="tipus === 'csoport_valtas'">
          <div class="aj-sor" *ngIf="tanulo">
            <div class="aj-mezo">
              <label>Melyik csoportból kerüljön KI?</label>
              <select [(ngModel)]="f.honnan" (ngModelChange)="valtozott()">
                <option value="">– nem kell kivenni –</option>
                <option *ngFor="let c of tanuloCsoportjai" [value]="c.id">{{ c.nev }}</option>
              </select>
            </div>
            <div class="aj-mezo">
              <label>Melyik csoportba kerüljön BE?</label>
              <input list="aj-csoportok" [(ngModel)]="f.hovaNev" (ngModelChange)="valtozott()" placeholder="– nem kell sehova – (gépelj)" autocomplete="off">
            </div>
          </div>
          <div class="aj-sor" *ngIf="tanulo">
            <div class="aj-mezo">
              <label>Melyik naptól?</label>
              <input type="date" [(ngModel)]="f.datum" (ngModelChange)="valtozott()" [min]="tanev.tankezd" [max]="tanev.tanvege">
              <span class="aj-sug">Az első nap, amikor már az új csoportba jár.</span>
            </div>
          </div>
          <label class="aj-pipa" *ngIf="tanulo && f.honnan">
            <input type="checkbox" [(ngModel)]="f.hianyzas_torles" (ngModelChange)="valtozott()">
            A régi csoportban e naptól beírt hiányzásait is töröld (hiszen nem oda járt)
          </label>
        </ng-container>

        <!-- Tanár (adminnak választható) -->
        <div class="aj-mezo" *ngIf="admin && (tipus === 'ora_felvetel' || tipus === 'ora_modositas' || tipus === 'ora_torles' || tipus === 'ora_elmaradt')">
          <label>Tanár</label>
          <select [(ngModel)]="f.tanar" (ngModelChange)="valtozott(); tipus !== 'ora_felvetel' && sorozatokBetolt()">
            <option *ngFor="let m of munkatarsak" [value]="m.adid">{{ m.nev }}</option>
          </select>
        </div>

        <!-- Hiányzó óra -->
        <ng-container *ngIf="tipus === 'ora_felvetel'">
          <div class="aj-sor">
            <div class="aj-mezo">
              <label>Nap</label>
              <select [(ngModel)]="f.nap" (ngModelChange)="valtozott()">
                <option *ngFor="let n of napok" [ngValue]="n.n">{{ n.nev }}</option>
              </select>
            </div>
            <div class="aj-mezo">
              <label>Hányadik óra</label>
              <select [(ngModel)]="f.ora" (ngModelChange)="valtozott()">
                <option *ngFor="let o of orak" [ngValue]="o">{{ o }}. óra</option>
              </select>
            </div>
          </div>
          <div class="aj-mezo">
            <label>Kivel? <a href="javascript:void(0)" (click)="f.egysegTipus = f.egysegTipus === 'csoport' ? 'osztaly' : 'csoport'; valtozott()">
              ({{ f.egysegTipus === 'csoport' ? 'egész osztállyal van?' : 'csoporttal van?' }})</a></label>
            <input *ngIf="f.egysegTipus === 'csoport'" list="aj-csoportok" [(ngModel)]="f.csoportNev" (ngModelChange)="valtozott()"
                   placeholder="csoport neve (gépelj)" autocomplete="off">
            <select *ngIf="f.egysegTipus === 'osztaly'" [(ngModel)]="f.osztaly" (ngModelChange)="valtozott()">
              <option *ngFor="let o of osztalyok" [value]="o.id">{{ o.nev }}</option>
            </select>
          </div>
          <div class="aj-sor">
            <div class="aj-mezo">
              <label>Tantárgy</label>
              <input list="aj-tantargyak" [(ngModel)]="f.tantargyNev" (ngModelChange)="valtozott()" placeholder="pl. korrepetálás - matek" autocomplete="off">
            </div>
            <div class="aj-mezo">
              <label>Terem (nem kötelező)</label>
              <select [(ngModel)]="f.terem" (ngModelChange)="valtozott()">
                <option value="">– a szokásos –</option>
                <option *ngFor="let t of termek" [value]="t.id">{{ t.nev }}</option>
              </select>
            </div>
          </div>
          <div class="aj-sor">
            <div class="aj-mezo">
              <label>Mettől?</label>
              <input type="date" [(ngModel)]="f.tol" (ngModelChange)="valtozott()" [min]="tanev.tankezd" [max]="tanev.tanvege">
            </div>
            <div class="aj-mezo">
              <label>Meddig? (üresen: ameddig az órarend tart)</label>
              <input type="date" [(ngModel)]="f.ig" (ngModelChange)="valtozott()" [min]="tanev.tankezd" [max]="tanev.tanvege">
            </div>
          </div>
        </ng-container>

        <!-- Rossz / nem létező óra: melyik órám? -->
        <ng-container *ngIf="tipus === 'ora_modositas' || tipus === 'ora_torles'">
          <div class="aj-mezo">
            <label>Melyik órádról van szó?</label>
            <div class="aj-sorozatok">
              <button type="button" class="aj-sorozat" *ngFor="let s of sorozatok" [class.valasztott]="s === sorozat" (click)="sorozatValaszt(s)">
                <span class="aj-idopont">{{ napNev(s.nap) }} {{ s.ora }}.</span>
                <span>{{ s.tantargy_nev }} · <b>{{ s.egyseg_nev || 'egység nélkül' }}</b>
                  <span class="aj-halvany"> · {{ s.terem_nev }} · {{ s.db }} óra ({{ s.elso }} – {{ s.utolso }})</span></span>
              </button>
              <span class="aj-sug" *ngIf="!sorozatok.length">Nincs órád a tanévben.</span>
            </div>
          </div>
          <div class="aj-sor" *ngIf="sorozat">
            <div class="aj-mezo">
              <label>{{ tipus === 'ora_torles' ? 'Melyik naptól nincs?' : 'Melyik naptól érvényes a javítás?' }}</label>
              <input type="date" [(ngModel)]="f.tol" (ngModelChange)="valtozott()" [min]="tanev.tankezd" [max]="tanev.tanvege">
            </div>
            <div class="aj-mezo">
              <label>Meddig? (üresen: a tanév végéig)</label>
              <input type="date" [(ngModel)]="f.ig" (ngModelChange)="valtozott()" [min]="tanev.tankezd" [max]="tanev.tanvege">
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="tipus === 'ora_modositas' && sorozat">
          <span class="aj-sug">Csak azt töltsd ki, ami rossz – a többi marad.</span>
          <div class="aj-sor">
            <div class="aj-mezo">
              <label>Helyes csoport</label>
              <input list="aj-csoportok" [(ngModel)]="f.ujCsoport" (ngModelChange)="valtozott()" placeholder="(változatlan)" autocomplete="off">
            </div>
            <div class="aj-mezo">
              <label>…vagy egész osztály</label>
              <select [(ngModel)]="f.ujOsztaly" (ngModelChange)="valtozott()" [disabled]="!!f.ujCsoport">
                <option value="">(változatlan)</option>
                <option *ngFor="let o of osztalyok" [value]="o.id">{{ o.nev }}</option>
              </select>
            </div>
          </div>
          <div class="aj-sor">
            <div class="aj-mezo">
              <label>Helyes tantárgy</label>
              <input list="aj-tantargyak" [(ngModel)]="f.ujTantargy" (ngModelChange)="valtozott()" placeholder="(változatlan)" autocomplete="off">
            </div>
            <div class="aj-mezo">
              <label>Helyes terem</label>
              <select [(ngModel)]="f.ujTerem" (ngModelChange)="valtozott()">
                <option value="">(változatlan)</option>
                <option *ngFor="let t of termek" [value]="t.id">{{ t.nev }}</option>
              </select>
            </div>
          </div>
          <div class="aj-sor">
            <div class="aj-mezo">
              <label>Helyes nap</label>
              <select [(ngModel)]="f.ujNap" (ngModelChange)="valtozott()">
                <option value="">(változatlan)</option>
                <option *ngFor="let n of napok" [ngValue]="n.n">{{ n.nev }}</option>
              </select>
            </div>
            <div class="aj-mezo">
              <label>Helyes óra</label>
              <select [(ngModel)]="f.ujOra" (ngModelChange)="valtozott()">
                <option value="">(változatlan)</option>
                <option *ngFor="let o of orak" [ngValue]="o">{{ o }}. óra</option>
              </select>
            </div>
          </div>
        </ng-container>

        <!-- Elmaradt órák -->
        <ng-container *ngIf="tipus === 'ora_elmaradt'">
          <div class="aj-sor">
            <div class="aj-mezo">
              <label>Melyik naptól?</label>
              <input type="date" [(ngModel)]="f.tol" (ngModelChange)="valtozott()" [min]="tanev.tankezd" [max]="tanev.tanvege">
            </div>
            <div class="aj-mezo">
              <label>Meddig? (üresen: csak az az egy nap)</label>
              <input type="date" [(ngModel)]="f.ig" (ngModelChange)="valtozott()" [min]="tanev.tankezd" [max]="tanev.tanvege">
            </div>
          </div>
          <div class="aj-mezo">
            <label>Miért? (nem kötelező)</label>
            <input [(ngModel)]="f.ok" maxlength="200" placeholder="pl. táppénz">
          </div>
          <span class="aj-sug">Csak a be nem írt, senki által nem helyettesített órák kerülnek „elmaradt” jelölésre. Ha valaki
            mégis megtartotta, ő a Helyettesítés bejelentésével jelzi – az adminisztrátor pedig visszavonhatja a jelölést.</span>
        </ng-container>

        <!-- Egyéb -->
        <div class="aj-mezo" *ngIf="tipus === 'egyeb'">
          <label>Mi a hibás adat, és mi lenne a helyes?</label>
          <textarea [(ngModel)]="f.szoveg" maxlength="4000"
                    placeholder="pl. S. Urbán Dávid (11.B) jogviszonya szünetel október 1-től, ne lehessen hiányzónak beírni."></textarea>
        </div>

        <div class="aj-mezo" *ngIf="tipus !== 'egyeb'">
          <label>Megjegyzés (nem kötelező)</label>
          <input [(ngModel)]="megjegyzes" maxlength="500" placeholder="pl. a KRÉTÁ-ban Marianna már javította">
        </div>

        <!-- Előnézet -->
        <div class="aj-elonezet" *ngIf="elonezet">
          <b>Ez fog történni:</b> {{ elonezet.osszegzes }}
          <ul>
            <li *ngFor="let l of elonezet.eredmeny?.lepesek">{{ l }}</li>
            <li class="figy" *ngFor="let w of elonezet.eredmeny?.figyelmeztetes">{{ w }}</li>
          </ul>
          <div *ngIf="!elonezet.kezi && !elonezet.valtozas_db" class="figy">Nincs mit javítani – az adat már most is így áll.</div>
        </div>
        <div class="aj-hiba" *ngIf="hiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ hiba }}</div>

        <div class="aj-gombok">
          <ion-button fill="outline" (click)="megse()">Mégse</ion-button>
          <ion-button *ngIf="!elonezet" (click)="ellenoriz()" [disabled]="dolgozik">
            <ion-spinner *ngIf="dolgozik" name="dots"></ion-spinner>Tovább – mi fog változni?
          </ion-button>
          <ion-button *ngIf="elonezet" color="success" (click)="vegrehajt()"
                      [disabled]="dolgozik || (!elonezet.kezi && !elonezet.valtozas_db)">
            <ion-spinner *ngIf="dolgozik" name="dots"></ion-spinner>
            {{ elonezet.kezi ? 'Beküldés' : 'Rendben, javítsd' }}
          </ion-button>
        </div>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- ══ BEJELENTÉSEK ════════════════════════════════════════════════════ -->
  <ion-card>
    <ion-card-header>
      <div class="aj-lista-fej">
        <ion-card-title>{{ osszes ? 'Az összes bejelentés' : 'Bejelentéseim' }}</ion-card-title>
        <ion-button *ngIf="admin" size="small" fill="outline" (click)="osszesValt()">
          {{ osszes ? 'Csak a sajátjaim' : 'Összes bejelentés' }}
        </ion-button>
      </div>
    </ion-card-header>
    <ion-card-content>
      <ion-spinner *ngIf="listaToltodik" name="dots"></ion-spinner>
      <div class="aj-sug" *ngIf="!listaToltodik && !bejelentesek.length">Még nincs bejelentés.</div>
      <div class="aj-bejelentes" *ngFor="let b of bejelentesek">
        <div class="aj-fej">
          <!--  Átnézendő csak a kézi javításra váró: az automatikusan végrehajtott bejelentés
                már megtörtént, itt látszik és visszavonható, de admin-teendő nincs vele. -->
          <span class="aj-uj" *ngIf="admin && osszes && !b.atnezve && b.allapot === 'kezire_var'">új</span>
          <ion-chip [color]="allapotSzin(b)">{{ allapotNev(b) }}</ion-chip>
          <span class="aj-cim">{{ b.osszegzes }}</span>
        </div>
        <div class="aj-meta">
          {{ tipusCim(b.tipus) }} · {{ b.bejelento_nev }} · {{ b.letrehozva | date:'yyyy. MM. dd. HH:mm' }}
          <span *ngIf="b.valtozas_db"> · {{ b.valtozas_db }} adatsor</span>
          <span *ngIf="b.visszavonva"> · visszavonta: {{ b.visszavonta }} ({{ b.visszavonva | date:'MM. dd. HH:mm' }})</span>
        </div>
        <div class="aj-lepesek" *ngIf="b.eredmeny?.lepesek?.length">{{ b.eredmeny.lepesek.join(' · ') }}</div>
        <div class="figy" *ngFor="let w of b.eredmeny?.figyelmeztetes">{{ w }}</div>
        <div class="aj-meta" *ngIf="b.megjegyzes">Megjegyzés: {{ b.megjegyzes }}</div>
        <div class="aj-meta" *ngIf="b.tipus === 'egyeb' && b.adatok?.szoveg">„{{ b.adatok.szoveg }}”</div>
        <div class="aj-meta" *ngIf="b.valasz"><b>Válasz:</b> {{ b.valasz }}</div>
        <div>
          <ion-button size="small" fill="outline" color="danger" *ngIf="b.allapot === 'vegrehajtva' && b.valtozas_db"
                      (click)="visszavon(b)">Visszavonás</ion-button>
          <ng-container *ngIf="admin && osszes">
            <ion-button size="small" fill="outline" color="success" *ngIf="b.allapot === 'kezire_var'" (click)="lezar(b, 'megoldva')">Megoldva</ion-button>
            <ion-button size="small" fill="outline" color="medium" *ngIf="b.allapot === 'kezire_var'" (click)="lezar(b, 'elutasitva')">Elutasítás</ion-button>
          </ng-container>
        </div>
      </div>
    </ion-card-content>
  </ion-card>
</ion-content>
